import { useState, useRef } from "react";
import * as Scrivito from "scrivito";
import ReactPaginate from "react-paginate";
import { Element, scroller } from "react-scroll";
import InPlaceEditingPlaceholder from "../../Components/InPlaceEditingPlaceholder";
import LightboxCarusel from "../../Components/LightboxCarusel";

const PAGE_SIZE = 15;

function AlbumGallery({ widget }) {
  const [currentPage, setCurrentPage] = useState(0);
  const [isLightboxVisible, setIsLightboxVisible] = useState(false);
  const [activeImage, setActiveImage] = useState(null);
  const ref = useRef();

  const scrollTo = () => {
    scroller.scrollTo("scroll-to-element", {
      duration: 800,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  };

  const handleClick = (page) => {
    scrollTo();
    setCurrentPage(page);
  };

  const toggleLightbox = (index = null) => {
    setIsLightboxVisible((v) => !v);
    setActiveImage(index);
  };

  const images = widget.get("images");

  if (!images.length) {
    return (
      <InPlaceEditingPlaceholder center>
        Select images in the widget properties.
      </InPlaceEditingPlaceholder>
    );
  }

  const pageCount = Math.ceil(images.length / PAGE_SIZE);

  return (
    <>
      {isLightboxVisible && (
        <LightboxCarusel
          images={images}
          activeImage={activeImage}
          toggleLightbox={toggleLightbox}
        />
      )}
      <div className="container album" ref={ref}>
        <Element id="scroll-to-element" />
        <br />
        <div className="row pb-3">
          {images
            .slice(currentPage * PAGE_SIZE, (currentPage + 1) * PAGE_SIZE)
            .map((image, i) => (
              <button
                className="col-md-4 no-decoration"
                key={`${image.id()}${i}`}
                onClick={() => toggleLightbox(i)}
              >
                <Scrivito.ImageTag
                  content={image}
                  className="image-tag mb-5"
                  loading="lazy"
                  width={image?.metadata().get("width")}
                  height={image?.metadata().get("height")}
                />
              </button>
            ))}
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 offset-md-3">
          <ReactPaginate
            previousLabel={<span className="las la-angle-left" />}
            nextLabel={<span className="las la-angle-right" />}
            breakLabel={<span>...</span>}
            breakClassName={"break"}
            pageCount={pageCount}
            marginPagesDisplayed={1}
            pageRangeDisplayed={2}
            onPageChange={(e) => handleClick(e.selected)}
            containerClassName={"pagination"}
            activeClassName={"active"}
            initialPage={currentPage}
            disableInitialCallback={true}
          />
        </div>
      </div>
    </>
  );
}

Scrivito.provideComponent("AlbumGalleryWidget", AlbumGallery);
